import React, { Component } from 'react'
import { calculateRisk } from "../modal.utils";
class RisksView extends Component {

    render() {
        let client = this.props.clientInfo;
        let resultRisk = calculateRisk(client.riskGeographic, client.riskProfile, client.riskOperationType);
        return (
            <fieldset>
                <div className="form-element">
                    <label className="form-element-label" htmlFor="">Риск по географическому региону</label>
                    <div className="form-element-data">
                        <div className="form-element-data-text">
                            <p>{client.riskGeographic}</p>
                        </div>
                    </div>
                </div>
                <div className="form-element">
                    <label className="form-element-label" htmlFor="">Риск по профилю клиента</label>
                    <div className="form-element-data">
                        <div className="form-element-data-text">
                            <p>{client.riskProfile}</p>
                        </div>
                    </div>
                </div>
                <div className="form-element">
                    <label className="form-element-label" htmlFor="">Риск по видам операций</label>
                    <div className="form-element-data">
                        <div className="form-element-data-text">
                            <p>{client.riskOperationType}</p>
                        </div>
                    </div>
                </div>
                <div className="form-element">
                    <label className="form-element-label" htmlFor="">Итоговая степень</label>
                    <div className="form-element-data">
                        <div className="form-element-data-text">
                            <p>{resultRisk ? "Низкий" : "Высокий"}</p>
                        </div>
                    </div>
                </div>
                {client.payerAccountNumber && <div className="form-element">
                    <label className="form-element-label" htmlFor="">Учётный номер
                        плательщика</label>
                    <div className="form-element-data textarea">
                        <div className="form-element-data-text">
                            <p>{client.payerAccountNumber}</p>
                        </div>
                    </div>
                </div>}
            </fieldset>
        )
    }
}

export default RisksView
